<!-- App.vue -->
<template>
  <Notivue v-slot="item">
    <Notification v-if="item" :item="item">
      <NotificationProgress
        v-if="item.meta && item.meta.showProgress"
        :item="item"
      />
    </Notification>
  </Notivue>

  <router-view />
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Notivue, Notification, NotificationProgress } from "notivue";

export default {
  name: "App",
  // registra os componentes do Notivue para o template poder usá-los
  components: {
    Notivue,
    Notification,
    NotificationProgress,
  },
  data() {
    return {
      inactivityTimer: null,
      resetInactivityTimer: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  watch: {
    $route(to) {
      if (to.path === "/admin/orders") {
        this.startInactivityTimer();
      } else {
        this.clearInactivityTimer();
      }
    },
  },
  mounted() {
    //this.clearToNewToken();
    this.checkAuth();
  },
  beforeUnmount() {
    this.clearInactivityTimer();
  },
  methods: {
    ...mapActions("auth", ["checkToken", "logout", "login"]),
    checkAuth() {},
    clearToNewToken() {
      if (this.isAuthenticated) {
        this.logout();
      }
    },
    startInactivityTimer() {
      if (this.$route.path !== "/admin/orders") return;
      const INACTIVITY_TIMEOUT = 10800000; // 3h
      const toast = this.$toast; // Use a instância global
      const resetInactivityTimer = () => {
        if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
        this.inactivityTimer = setTimeout(() => {
          if (this.isAuthenticated) {
            this.logout().then(() => {
              this.$router.push({ path: "/" });
              toast.error(
                "Seu token expirou. Por favor, efetue o login novamente.",
              );
            });
          }
        }, INACTIVITY_TIMEOUT);
      };
      this.resetInactivityTimer = resetInactivityTimer;
      window.addEventListener("mousemove", this.resetInactivityTimer);
      window.addEventListener("keydown", this.resetInactivityTimer);
      resetInactivityTimer();
    },
    clearInactivityTimer() {
      if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
      if (this.resetInactivityTimer) {
        window.removeEventListener("mousemove", this.resetInactivityTimer);
        window.removeEventListener("keydown", this.resetInactivityTimer);
      }
    },
  },
};
</script>

<style scoped></style>
